import { render, staticRenderFns } from "./VipCardScan.vue?vue&type=template&id=57dba20f&scoped=true"
import script from "./VipCardScan.vue?vue&type=script&lang=js"
export * from "./VipCardScan.vue?vue&type=script&lang=js"
import style0 from "./VipCardScan.vue?vue&type=style&index=0&id=57dba20f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dba20f",
  null
  
)

export default component.exports